import { useState } from "react";

const ElementName: Record<number, string> = {
  0: "Огонь",
  1: "Вода",
  2: "Воздух",
  3: "Земля",
};

const ElementKey: Record<number, string> = {
  0: "fire",
  1: "water",
  2: "air",
  3: "earth",
};

const Fallback: Record<number, string> = {
  0: "🔥",
  1: "💧",
  2: "💨",
  3: "🪨",
};

// Heraldic crest for the player's element. PNG with emoji fallback so we
// don't have a broken-icon state while art is being generated.
export function ElementEmblem({
  element,
  size = 32,
  className = "",
}: {
  element: number;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const key = ElementKey[element];
  if (failed || !key) {
    return (
      <span
        title={ElementName[element]}
        className={className}
        style={{ fontSize: size, lineHeight: 1 }}
      >
        {Fallback[element] ?? "❓"}
      </span>
    );
  }
  return (
    <img
      src={`/icons/emblems/${key}-v2.png`}
      alt={ElementName[element]}
      title={ElementName[element]}
      style={{ width: size, height: size, objectFit: "contain" }}
      onError={() => setFailed(true)}
      className={`inline-block ${className}`.trim()}
      loading="lazy"
    />
  );
}
